<template>
    <div
        :class="[
            'dynamic-fields',
            { 'display--grid': hasFields }
        ]"
    >   <template v-if="hasFields">
            <base-field
                v-for="( key, index ) in fields"
                :class="[
                    'dynamic-fields__input',
                    { 'dynamic-fields__input--padding': index === fields.length - 1 }
                ]"
                :settings="{
                    label: { class: 'capitalize', text: translations[index] ? $t(`global.${translations[index]}`) : key },
                    input: {
                        ...( !isEdition && {
                            component: 'InputBasic',
                            name: key,
                            type: 'text',
                            class: 'field__input--default typography--default color--default',
                            browserAutocomplete: key,
                            isRequired: false
                        }),
                        name: key,
                        value: obj[key],
                        disableClass: 'dynamic-fields__input__element'
                    },
                    isEdition,
                    allowFilling
                }"
                :key="index"
            />
        </template>
        <div class="dynamic-fields__empty" v-else-if="showEmptyMessage">{{ $t('warning.notAvailable') }}</div>
        <slot />
    </div>
</template>

<script>
// package
import { computed } from '@vue/composition-api';

export default {
    components: {
        BaseField: () => import( /* webpackChunkName: 'BaseField'  */ '@/components/bundles/fields/BaseField' )
    },
    props: {
        obj: {
            type: Object,
            default: () => ({ })
        },
        showEmptyMessage: {
            type: Boolean,
            default: true
        },
        isEdition: {
            type: Boolean,
            default: false
        },
        allowFilling: {
            type: Boolean,
            default: false
        },
        translations: {
            type: Array,
            default: () => ( [ ] )
        }
    },
    setup ( props ) {
        // ordenação dos campos alfabeticamente.
        const fields = computed( () => Object.keys( props.obj ).sort( ( currentKey, nextKey ) => currentKey.localeCompare( nextKey ) ) );
        // validação se o objecto tem campos ou não.
        const hasFields = computed( () => Object.keys( props.obj ).length );

        return { fields, hasFields };
    }
};
</script>

<style lang="scss">
    .dynamic-fields {
        &__input {
            &--padding {
                padding-bottom: 40px;
            }
            &__element {
                padding-right: 15px;
            }
        }
    }
</style>